import { Card, Metric, Text, Flex, ProgressBar } from "@tremor/react";

const CaseStatsSummary = ({ summary }) => {
  if (!summary) return null;

  const cards = [
    {
      title: "Σύνολο Υποθέσεων",
      metric: summary.totalCases,
      color: "blue",
    },
    {
      title: "Μέσος Χρόνος από Κατάθεση έως Δικάσιμο",
      metric:
        summary.avgDaysToHearing !== null
          ? `${summary.avgDaysToHearing} ημέρες`
          : "Μ/Δ",
      subtext:
        summary.medianDaysToHearing !== null
          ? `Διάμεσος: ${summary.medianDaysToHearing} ημέρες`
          : null,
      color: "blue",
    },
    {
      title: "Μέσος Χρόνος από Δικάσιμο έως Δημοσίευση",
      metric:
        summary.avgDaysToPublication !== null
          ? `${summary.avgDaysToPublication} ημέρες`
          : "Μ/Δ",
      subtext:
        summary.medianDaysToPublication !== null
          ? `Διάμεσος: ${summary.medianDaysToPublication} ημέρες`
          : null,
      color: "amber",
    },
    {
      title: "Μέσος Χρόνος από Κατάθεση έως Δημοσίευση",
      metric:
        summary.avgDaysDepositToPublication !== null
          ? `${summary.avgDaysDepositToPublication} ημέρες`
          : "Μ/Δ",
      subtext:
        summary.medianDaysDepositToPublication !== null
          ? `Διάμεσος: ${summary.medianDaysDepositToPublication} ημέρες`
          : null,
      color: "emerald",
    },
    {
      title: "Ποσοστό Ολοκλήρωσης",
      metric: `${(summary.completionRate * 100).toFixed(1)}%`,
      subtext: `${summary.casesWithPublication} από ${summary.totalCases} υποθέσεις`,
      color: "violet",
      showProgress: true,
      progress: summary.completionRate * 100,
    },
    {
      title: "Υποθέσεις με Δικάσιμο",
      metric: summary.casesWithHearing,
      subtext: `${(
        (summary.casesWithHearing / summary.totalCases) *
        100
      ).toFixed(1)}% του συνόλου`,
      color: "cyan",
    },
    {
      title: "Εκκρεμείς Δικάσιμοι",
      metric: summary.pendingHearings,
      subtext: "Προγραμματισμένα στο μέλλον",
      color: "rose",
    },
  ];

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {cards.map((card, index) => (
        <Card key={index} decoration="top" decorationColor={card.color}>
          <Text>{card.title}</Text>
          <Metric>{card.metric}</Metric>
          {card.subtext && (
            <Text className="mt-1 text-sm text-gray-600">{card.subtext}</Text>
          )}
          {card.showProgress && (
            <ProgressBar
              value={card.progress}
              color={card.color}
              className="mt-2"
            />
          )}
        </Card>
      ))}
    </div>
  );
};

export default CaseStatsSummary;
